import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { State } from './types';
import { baseQuery, endpoints } from 'utils/api/endpoints';

export const initialState: State = {};

const slice = createSlice({
  name: 'profile',
  initialState,
  reducers: {},
});

export const api = createApi({
  reducerPath: 'profileApi',
  baseQuery,
  endpoints: builder => ({
    getProfile: builder.query<any, void>({
      query: () => {
        return {
          url: endpoints.PROFILE + '/profile',
          method: 'GET',
        };
      },
    }),
    updateProfile: builder.mutation<any, any>({
      query: data => {
        return {
          url: endpoints.PROFILE + '/profile',
          method: 'PUT',
          body: data,
        };
      },
    }),
    changePassword: builder.mutation<any, any>({
      query: data => {
        return {
          url: endpoints.PROFILE + '/change-password',
          method: 'POST',
          body: data,
        };
      },
    }),
    changeEmail: builder.mutation<any, any>({
      query: data => {
        return {
          url: endpoints.PROFILE + '/change-email',
          method: 'POST',
          body: data,
        };
      },
    }),
    getMicrosoft2FAStatus: builder.query<any, void>({
      query: () => {
        return {
          url: endpoints.PROFILE + '/microsoft-2fa/status',
          method: 'GET',
        };
      },
    }),
    setupMicrosoft2FA: builder.mutation<any, any>({
      query: data => {
        return {
          url: endpoints.PROFILE + '/microsoft-2fa/setup',
          method: 'POST',
          body: data,
        };
      },
    }),
    verifyMicrosoft2FASetup: builder.mutation<any, any>({
      query: data => {
        return {
          url: endpoints.PROFILE + '/microsoft-2fa/verify',
          method: 'POST',
          body: data,
        };
      },
    }),
    disableMicrosoft2FA: builder.mutation<any, any>({
      query: data => {
        return {
          url: endpoints.PROFILE + '/microsoft-2fa/disable',
          method: 'POST',
          body: data,
        };
      },
    }),
    verifyMicrosoft2FAToken: builder.mutation<any, any>({
      query: data => {
        return {
          url: endpoints.PROFILE + '/microsoft-2fa/verify-token',
          method: 'POST',
          body: data,
        };
      },
    }),
    regenerateBackupCodes: builder.mutation<any, any>({
      query: data => {
        return {
          url: endpoints.PROFILE + '/backup-codes/regenerate',
          method: 'POST',
          body: data,
        };
      },
    }),
    getBackupCodesStatus: builder.query<any, void>({
      query: () => {
        return {
          url: endpoints.PROFILE + '/backup-codes/status',
          method: 'GET',
        };
      },
    }),
    getBackupCodes: builder.query<any, void>({
      query: () => {
        return {
          url: endpoints.PROFILE + '/backup-codes/all',
          method: 'GET',
        };
      },
    }),
  }),
});

export const { actions: profileActions } = slice;

export const useProfileSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    actions: slice.actions,
    useGetProfileQuery: api.useLazyGetProfileQuery,
    useUpdateProfileMutation: api.useUpdateProfileMutation,
    useChangePasswordMutation: api.useChangePasswordMutation,
    useChangeEmailMutation: api.useChangeEmailMutation,
    useGetMicrosoft2FAStatusQuery: api.useLazyGetMicrosoft2FAStatusQuery,
    useSetupMicrosoft2FAMutation: api.useSetupMicrosoft2FAMutation,
    useVerifyMicrosoft2FASetupMutation: api.useVerifyMicrosoft2FASetupMutation,
    useDisableMicrosoft2FAMutation: api.useDisableMicrosoft2FAMutation,
    useVerifyMicrosoft2FATokenMutation: api.useVerifyMicrosoft2FATokenMutation,
    useRegenerateBackupCodesMutation: api.useRegenerateBackupCodesMutation,
    useGetBackupCodesStatusQuery: api.useLazyGetBackupCodesStatusQuery,
    useGetBackupCodesQuery: api.useLazyGetBackupCodesQuery,
  };
};
